// routes
import Router from "./routes";
// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
// hooks
//import useAuth from "./hooks/useAuth";
// components
//import Settings from './core/components/settings';
import { BaseOptionChartStyle } from "./core/components/charts/BaseOptionChart";
import LoadingScreen, {
  ProgressBarStyle,
} from "./core/components/LoadingScreen";
import NotistackProvider from "./core/components/NotistackProvider";
import RtlLayout from "./core/components/RtlLayout";
import ScrollToTop from "./core/components/ScrollToTop";
import ThemeLocalization from "./core/components/ThemeLocalization";
import ThemePrimaryColor from "./core/components/ThemePrimaryColor";
//import useAuth from "./hooks/useAuth";

function App() {
  //const { isInitialized } = useAuth();

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <ThemeLocalization>
          <RtlLayout>
            <NotistackProvider>
              <GlobalStyles />
              <ProgressBarStyle />
              <BaseOptionChartStyle />
              {/* <Settings /> */}
              <ScrollToTop />
              {/* {isInitialized ? <Router /> : <LoadingScreen />} */}
              <Router /> 
            </NotistackProvider>
          </RtlLayout>
        </ThemeLocalization>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}

export default App;
